<div class="resource-types-container">
    {{ "playbooks.triggersConfigurationLabels.supportedResourceTypes" | labelsProvider }}
    <span class="info-icon" tabindex="0" aria-label="Supported resource types">
        <img src="assets/images/dashboards-icons/info.svg" alt="Info" />
        <div class="info-tooltip">
            <ul>
                <li *ngFor="let resourceType of resourceTypeOptions$ | async">
                    {{ resourceType.displayName }}
                </li>
            </ul>
        </div>
    </span>
</div>
